import React, { useState } from 'react';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import pdf from 'html2pdf.js';

import { useSelector } from 'react-redux';
import { Container, Filtros } from '../../styles/GlobalStyles';
import { Relatorio, Lista, Title } from './styled';
import axios from '../../services/axios';

export default function Relatorios() {
  const [concurso, setConcurso] = useState([]);
  const [disciplina, setDisciplina] = useState([]);

  const nivel = useSelector((state) => state.auth.user.nivel);

  const getDatasConcurso = async (results) => {
    setDisciplina([]);

    const aberto = document.getElementById('aberto');

    const finalizados = document.getElementById('finalizados');

    const proximasProva = document.getElementById('proximas-prova');

    const provasFinalizadas = document.getElementById('provas-anteriores');

    let filteredResults = results;

    if (aberto.checked) {
      filteredResults = filteredResults.filter((res) => dayjs().isBefore(res.data_fim_inscricoes, 'day') === true);
    }

    if (finalizados.checked) {
      filteredResults = filteredResults.filter((res) => dayjs().isAfter(res.data_fim_inscricoes, 'day') === true);
    }

    if (proximasProva.checked) {
      filteredResults = filteredResults.filter((res) => dayjs().isBefore(res.data_prova, 'day') === true);
    }

    if (provasFinalizadas.checked) {
      filteredResults = filteredResults.filter((res) => dayjs().isAfter(res.data_prova, 'day') === true);
    }

    setConcurso(filteredResults);
  };

  const getDatasDisciplina = async (results) => {
    setConcurso([]);

    const filteredResults = results;

    setDisciplina(filteredResults);
  };

  const choice = async (e) => {
    try {
      if ((e.target.value === 'relatorios' || e.target.value === 'disciplina')
      && nivel !== '0') {
        const response = await axios(`/${e.target.value}/`);
        if (e.target.value === 'relatorios') {
          getDatasConcurso(response.data);
        } else if (e.target.value === 'disciplina') {
          getDatasDisciplina(response.data);
        }
      }
    } catch (err) {
      toast.error('Não foi possível gerar o relatório');
    }
  };

  const gerarPdf = () => {
    // Conteúdo HTML que deve estar no PDF
    const content = document.getElementById('pdf');

    // Configuração do arquivo final de PDF
    const options = {
      margin: 10,
      filename: 'relatorio.pdf',
      html2canvas: { scale: 1, width: concurso.length > 0 ? 1440 : 850 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'l' },
    };

    // Gerar e baixar o PDF
    pdf().set(options).from(content).save();
  };

  return (
    <Container>

      <Title>Relatórios</Title>

      <Lista>
        <label htmlFor="concurso">
          <input id="concurso" onClick={(e) => choice(e)} name="opcao" value="relatorios" type="radio" />
          Concursos
        </label>

        <label htmlFor="disciplina">
          <input id="disciplina" onClick={(e) => choice(e)} name="opcao" value="disciplina" type="radio" />
          Disciplinas
        </label>
      </Lista>

      <Filtros style={{ margin: '0rem -1rem', display: disciplina.length > 0 ? 'none' : 'flex' }}>

        <div>
          <label htmlFor="aberto">
            <input id="aberto" type="checkbox" />
            Concursos em aberto
          </label>
        </div>

        <div>
          <label htmlFor="finalizados">
            <input id="finalizados" type="checkbox" />
            Concursos finalizados
          </label>
        </div>
        <div>
          <label htmlFor="proximas-prova">
            <input id="proximas-prova" type="checkbox" />
            Próximas provas
          </label>
        </div>

        <div>
          <label htmlFor="provas-anteriores">
            <input id="provas-anteriores" type="checkbox" />
            Provas Realizadas
          </label>
        </div>

      </Filtros>

      <Relatorio>
        <table id="pdf">

          <thead>
            {concurso.length > 0 && (
              <tr>
                <th>Código</th>
                <th>Nome empresa</th>
                <th>Data inicial inscrisções</th>
                <th>Data final inscrisções</th>
                <th>Hora inicial inscrisções</th>
                <th>Hora final inscrisções</th>
                <th>Data prova</th>
                <th>Hora inicial prova</th>
                <th>Hora final prova</th>
                <th>Tempo prova</th>
                <th>Data envio recurso</th>
                <th>Data limite recurso</th>
                <th>Hora incial recurso</th>
                <th>Hora final recurso</th>
                <th>Email envio recurso</th>
                <th>Data resultado provisório</th>
                <th>Data resultado oficial</th>
                <th>Data limite visualização</th>
              </tr>
            )}

            {disciplina.length > 0 && (
              <tr>
                <th>Código</th>
                <th>Nível do curso</th>
                <th>Descrição disciplina</th>
                <th>Quantidade questões</th>
                <th>Utilizar mesma prova</th>
                <th>Tipos de prova</th>
              </tr>
            )}
          </thead>

          <tbody>
            {concurso.length > 0 && (concurso.map((res) => (
              <tr key={uuidv4()}>
                <td>{res.id}</td>
                <td>{res.nome_empresa}</td>
                <td>{res.data_inicio_inscricoes}</td>
                <td>{res.data_fim_inscricoes}</td>
                <td>{res.hora_inicio_inscricoes}</td>
                <td>{res.hora_fim_inscricoes}</td>
                <td>{res.data_prova}</td>
                <td>{res.hora_inicio_prova}</td>
                <td>{res.hora_fim_prova}</td>
                <td>{res.tempo_realizacao_prova}</td>
                <td>{res.data_envio_recurso}</td>
                <td>{res.data_limite_envio_recurso}</td>
                <td>{res.hora_inicio_recurso}</td>
                <td>{res.hora_fim_recurso}</td>
                <td>{res.email_envio_recurso}</td>
                <td>{res.data_publicacao_resultado_provisorio}</td>
                <td>{res.data_publicacao_resultado_oficial}</td>
                <td>{res.data_limite_visualizacao}</td>
              </tr>
            )))}

            {disciplina.length > 0 && (
              disciplina.map((res) => (
                <tr key={uuidv4()}>
                  <td>{res.id}</td>
                  <td>{res.curso_nivel}</td>
                  <td>{res.descricao_disciplina}</td>
                  <td>{res.quantidade_questoes}</td>
                  <td>{res.utilizar_mesma_prova}</td>
                  <td>{res.tipos_de_prova}</td>
                </tr>
              ))
            )}

          </tbody>

        </table>

        {((concurso.length > 0 || disciplina.length > 0) && nivel !== '0')
      && (<button type="button" onClick={gerarPdf}>Gerar PDF</button>)}
      </Relatorio>

    </Container>
  );
}
